import { useEffect, useMemo, useState } from 'react';

export const Countdown = ({ deadline }) => {
  const [timeLeft, setTimeLeft] = useState({ d: 0, h: 0, m: 0, s: 0 });
  const target = useMemo(() => new Date(deadline).getTime(), [deadline]);

  useEffect(() => {
    const tick = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      setTimeLeft({ d, h, m, s });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  const labels = {
    d: 'DAYS',
    h: 'HOURS',
    m: 'MIN',
    s: 'SEC'
  };

  return (
    <div
      data-testid="countdown-timer"
      role="timer"
      aria-live="polite"
      className="inline-flex items-center gap-2 rounded-2xl border border-[rgba(216,224,5,0.35)] bg-[#1c334a] backdrop-blur-sm px-3 py-2"
    >
      {['d', 'h', 'm', 's'].map((k, i) => (
        <div key={k} className="flex items-center">
          <div className="flex flex-col items-center">
            <span className="text-xl font-black text-[#d8e005] tabular-nums">
              {String(timeLeft[k]).padStart(2, '0')}
            </span>
            <span className="text-[9px] text-white/70 uppercase font-medium tracking-wider mt-0.5">
              {labels[k]}
            </span>
          </div>
          {i < 3 && <span className="mx-1.5 text-white/60 text-sm">:</span>}
        </div>
      ))}
    </div>
  );
};

